Bacon = require 'baconjs'
R = require 'ramda'

{ loadResourceFromUrl, findResourceLink } = require "utils/resources"
{ createResource, updateResource } = require "utils/resources"

feedbackStore = require "stores/feedback"

currentOrder = feedbackStore.order

customerUrlStream = currentOrder
    .map R.path ['customer', 'customer_url']

marketingStream = new Bacon.Bus
setMarketingStream = new Bacon.Bus

updateMarketing = setMarketingStream
    .debounce(1000)
    .combine customerUrlStream, (marketing_opt_in, url) ->
      { url, user: { marketing_opt_in } }
    .flatMap updateResource
    .map R.path [ 'user', 'marketing' ]

loadMarketingState = customerUrlStream
    .flatMap loadResourceFromUrl
    .map R.path([ 'user', 'marketing' ])

marketingState = Bacon
    .mergeAll loadMarketingState, updateMarketing
    .toProperty()

marketingState.onValue ->

module.exports =
    marketing: marketingState
    setMarketing: (optIn) ->
      setMarketingStream.push optIn